import type { Props } from '~/types/component-props';

export * from './RadixMenu';

export * from './Menu';

export type MenuItemProps<T extends React.ElementType = 'button'> = Props<T> & {
  children: React.ReactNode;
  iconLeading?: React.ReactNode;
  iconTrailing?: React.ReactNode;
};
